import { useMemo } from 'react'

import { CalendarFilter } from '../../models/CalendarFilter'
import { Item } from '../../models/Item'
import { User } from '../../models/User'
import Tag from '../app/design/Tag'
import { CalendarScrollX } from './CalendarScrollX'

type Props = {
    filter: CalendarFilter
    pros: User[]
    items: Item[]
    onRemove: (filter: CalendarFilter) => void
}

export const CalendarFilterTags = ({ filter, pros, items, onRemove }: Props) => {
    const filteredPros = useMemo(
        () => pros.filter((u) => !!u.id && filter.allPeople.includes(u.id)),
        [filter.allPeople, pros]
    )

    const filteredItems = useMemo(
        () => items.filter((i) => !!i.id && filter.allItems.includes(i.id)),
        [filter.allItems, items]
    )

    const removeProFromFilter = (id: string | undefined) => {
        if (!id) return
        filter.removePersonWithId(id)
        onRemove(filter.copy())
    }

    const removeItemFromFilter = (id: string | undefined) => {
        if (!id) return
        filter.removeItemWithId(id)
        onRemove(filter.copy())
    }

    return (
        <div className="mt-4 mb-6">
            <CalendarScrollX
                deps={[filter, filteredPros, filteredItems]}
                style={{
                    wrapper: { gap: '8px', margin: '0 -32px', padding: '0 64px' },
                    overflow: { padding: '0 72px' },
                }}
            >
                {filteredPros.map((pro) => (
                    <Tag
                        key={pro.id}
                        label={pro.name || ''}
                        size="sm"
                        intent="success"
                        onClose={() => removeProFromFilter(pro.id)}
                    />
                ))}
                {filteredItems.map((item) => (
                    <Tag
                        key={item.id}
                        label={item.name || ''}
                        size="sm"
                        intent="success"
                        onClose={() => removeItemFromFilter(item.id)}
                    />
                ))}
            </CalendarScrollX>
        </div>
    )
}
